import axios from 'axios';
import { baseUrl } from '../utils';

export const getClarityIdByName = async (themeName: string): Promise<string> => {
  try {
    const encodedName = encodeURIComponent(themeName);
    const url = `${baseUrl}/whitelabel/clarity-by-name/${encodedName}`;
    
    const response = await axios.get(url);
    return response.data.clarityId || 'rqloengqf3';
  } catch (error) {
    console.error('Error fetching Clarity ID:', error);
    
    if (axios.isAxiosError(error) && error.response?.data?.clarityId) {
      return error.response.data.clarityId;
    }
    
    // Ultimate fallback
    return 'rqloengqf3';
  }
};

// Keep the old function for backward compatibility
export const getClarityId = getClarityIdByName;